// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DDh-","comment":"styles_comment__24lWF"};